module.exports = __webpack_public_path__ + "img/landmark.3cbb7272.svg";